import { setupCookieConsent } from './module/CookieConsentFunctions';

// 設定オブジェクト
const config = {
  consentPopupId: 'cookie-consent-popup',
  consentButtonId: 'cookie-consent-button',
  consentKey: 'cookieConsent-kyoto',
  displayClass: 'u-displayBlock'
};

// DOMの読み込みが完了したら設定する
window.addEventListener('load', () => {
  setupCookieConsent(config);
});
